// extracted by mini-css-extract-plugin
module.exports = {"top":"recentLaunches_top__32F-p","main":"recentLaunches_main__1la3F"};